export default function getSearchParamUrl(location, parameter) {
  if (parameter) {
    return new URLSearchParams(location.search).get(parameter);
  }
  return location.search;
}